import { isEmpty } from 'lodash-es';
import { SearchMethod } from '../../../../../analytics/types';
import { internalApi } from '../../../../../internal-api';
import { orderAssistLogger } from '../../../logger';
import {
  FindQuery,
  FindResponse,
  GetOrderAssistInput,
  GetOrderAssistResult,
  UHC,
  WidgetSource,
} from '../../../types';

import { getFindQuery, getResults } from './formatters';

const responseFormatter = (
  findInput: FindQuery,
  findResponse: FindResponse,
  pageSize: number,
): GetOrderAssistResult => {
  const { results, alternativeResults, implementationSpecificFields, pagination } = findResponse;
  const responseSpecificFields = implementationSpecificFields as UHC.ResponseSpecificFields;
  const { benefits, disclaimers, providerCacheId, isCostAvailable, distanceInfo } =
    responseSpecificFields || {};
  const basicRankStarter = (pagination.pageNumber - 1) * pageSize;
  const rankStarters = {
    results: basicRankStarter,
    alternativeResults: basicRankStarter + results.length,
  };

  const isTeladocOutOfNetwork = Boolean(
    findInput?.tenantSpecificFilters &&
      results?.length &&
      results.some((result) => !result.teladocGarner?.networkStatus),
  );

  return {
    searchResults: getResults({ results, rankStarter: rankStarters.results }),
    alternativeResults: getResults({
      results: alternativeResults,
      rankStarter: rankStarters.alternativeResults,
    }),
    disclaimers,
    pagination,
    providerCacheId,
    distanceInfo,
    costAvailable: isCostAvailable,
    benefits: isEmpty(benefits) ? undefined : benefits,
    isOutOfNetworkResults:
      isTeladocOutOfNetwork ||
      (!findInput.searchParams?.encryptedIdentifyInput &&
        !findInput.searchParams?.anonymizedPatient &&
        !findInput.filters?.memberPlan),
  };
};

export const find = async (
  input: GetOrderAssistInput & {
    useGeoCoordinatesOnly: boolean;
    useGarnersSpecialtiesInput: boolean;
    pageSize: number;
  },
  method: SearchMethod,
  source: WidgetSource | undefined,
): Promise<GetOrderAssistResult | undefined> => {
  try {
    const findQuery = getFindQuery(input);

    const findResponse = await internalApi.orderAssistBff.find(findQuery, method, source);

    const orderAssistResult = responseFormatter(findQuery, findResponse, input.pageSize);
    orderAssistLogger.info('Order Assist find query result', { orderAssistResult });
    return orderAssistResult;
  } catch (error) {
    orderAssistLogger.error('Failed to find', { error });
    return undefined;
  }
};
